/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IntegrationMappingEntity,
} from '../models/index';
import {
    IntegrationMappingEntityFromJSON,
    IntegrationMappingEntityToJSON,
} from '../models/index';

export interface CreateMappingRequest {
    instanceId: string;
    integrationMappingEntity: IntegrationMappingEntity;
    sessionId?: string;
}

export interface GetCanonicalFieldsRequest {
    entityType: string;
}

export interface GetFieldAliasesRequest {
    entityType: string;
    canonicalField: string;
}

export interface GetFieldAliasesBatchRequest {
    entityType: string;
    requestBody: Array<string>;
}

export interface GetFieldMappingHistoryRequest {
    mappingId: string;
    destinationField: string;
    sessionId?: string;
}

export interface GetMappingRequest {
    mappingId: string;
    sessionId?: string;
}

export interface GetMappingVersionsRequest {
    mappingId: string;
    sessionId?: string;
}

export interface GetMappingsRequest {
    instanceId: string;
    sessionId?: string;
}

export interface NormalizeMappingPreviewRequest {
    entityType: string;
    requestBody: { [key: string]: any; };
    sourceSystem?: string;
}

export interface RollbackMappingRequest {
    mappingId: string;
    versionNumber: number;
    sessionId?: string;
}

export interface UpdateMappingRequest {
    mappingId: string;
    changeSummary: string;
    changeReason: string;
    changeCategory: UpdateMappingChangeCategoryEnum;
    integrationMappingEntity: IntegrationMappingEntity;
    sessionId?: string;
}

export interface ValidateFieldNameRequest {
    entityType: string;
    fieldName: string;
}

export interface ValidateFieldNamesBatchRequest {
    entityType: string;
    requestBody: Array<string>;
}

export interface ValidateInstanceRoutingRequest {
    instanceId: string;
}

/**
 * IntegrationMarketplaceMappingsApi - interface
 * 
 * @export
 * @interface IntegrationMarketplaceMappingsApiInterface
 */
export interface IntegrationMarketplaceMappingsApiInterface {
    /**
     * Create a new field mapping for an integration instance
     * @summary Create mapping
     * @param {string} instanceId Instance ID
     * @param {IntegrationMappingEntity} integrationMappingEntity 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceMappingsApiInterface
     */
    createMappingRaw(requestParameters: CreateMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Create a new field mapping for an integration instance
     * Create mapping
     */
    createMapping(requestParameters: CreateMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get all canonical field names for a given entity type (ASSET, APPLICATION, CONTAINER, VULNERABILITY, WEAKNESS, USER)
     * @summary Get canonical fields
     * @param {string} entityType Entity type (ASSET, APPLICATION, CONTAINER, VULNERABILITY, WEAKNESS, USER)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceMappingsApiInterface
     */
    getCanonicalFieldsRaw(requestParameters: GetCanonicalFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get all canonical field names for a given entity type (ASSET, APPLICATION, CONTAINER, VULNERABILITY, WEAKNESS, USER)
     * Get canonical fields
     */
    getCanonicalFields(requestParameters: GetCanonicalFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get common field name aliases/variations for a canonical field name
     * @summary Get field aliases
     * @param {string} entityType Entity type
     * @param {string} canonicalField Canonical field name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceMappingsApiInterface
     */
    getFieldAliasesRaw(requestParameters: GetFieldAliasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get common field name aliases/variations for a canonical field name
     * Get field aliases
     */
    getFieldAliases(requestParameters: GetFieldAliasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get common field name aliases/variations for multiple canonical field names in a single request
     * @summary Get field aliases for multiple fields (batch)
     * @param {string} entityType Entity type
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceMappingsApiInterface
     */
    getFieldAliasesBatchRaw(requestParameters: GetFieldAliasesBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get common field name aliases/variations for multiple canonical field names in a single request
     * Get field aliases for multiple fields (batch)
     */
    getFieldAliasesBatch(requestParameters: GetFieldAliasesBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get change history for a single destination field within a mapping (add/remove/update with who and when)
     * @summary Get field mapping history
     * @param {string} mappingId Mapping ID
     * @param {string} destinationField Destination field name to filter by
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceMappingsApiInterface
     */
    getFieldMappingHistoryRaw(requestParameters: GetFieldMappingHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get change history for a single destination field within a mapping (add/remove/update with who and when)
     * Get field mapping history
     */
    getFieldMappingHistory(requestParameters: GetFieldMappingHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get mapping configuration including mapping-scoped trigger rules
     * @summary Get mapping
     * @param {string} mappingId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceMappingsApiInterface
     */
    getMappingRaw(requestParameters: GetMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get mapping configuration including mapping-scoped trigger rules
     * Get mapping
     */
    getMapping(requestParameters: GetMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get version history for a field mapping
     * @summary Get mapping versions
     * @param {string} mappingId Mapping ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceMappingsApiInterface
     */
    getMappingVersionsRaw(requestParameters: GetMappingVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get version history for a field mapping
     * Get mapping versions
     */
    getMappingVersions(requestParameters: GetMappingVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get all field mappings for an integration instance
     * @summary Get mappings
     * @param {string} instanceId Instance ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceMappingsApiInterface
     */
    getMappingsRaw(requestParameters: GetMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get all field mappings for an integration instance
     * Get mappings
     */
    getMappings(requestParameters: GetMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get all available transform types for field mappings
     * @summary Get transform types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceMappingsApiInterface
     */
    getTransformTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get all available transform types for field mappings
     * Get transform types
     */
    getTransformTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Apply FieldNormalizationService to a transformed mapping preview record so operators see canonical keys MDM/load will receive
     * @summary Normalize mapped record preview
     * @param {string} entityType Entity type (ASSET, USER, …)
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sourceSystem] Optional source system for CSPM-specific alias maps
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceMappingsApiInterface
     */
    normalizeMappingPreviewRaw(requestParameters: NormalizeMappingPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Apply FieldNormalizationService to a transformed mapping preview record so operators see canonical keys MDM/load will receive
     * Normalize mapped record preview
     */
    normalizeMappingPreview(requestParameters: NormalizeMappingPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Rollback to a previous version of a field mapping
     * @summary Rollback mapping
     * @param {string} mappingId Mapping ID
     * @param {number} versionNumber Version number to rollback to
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceMappingsApiInterface
     */
    rollbackMappingRaw(requestParameters: RollbackMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Rollback to a previous version of a field mapping
     * Rollback mapping
     */
    rollbackMapping(requestParameters: RollbackMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Update field mapping - automatically creates new version and recommends replay if needed
     * @summary Update mapping
     * @param {string} mappingId Mapping ID
     * @param {string} changeSummary Change summary
     * @param {string} changeReason Change reason
     * @param {'BUG_FIX' | 'FEATURE_ADDITION' | 'OPTIMIZATION' | 'SCHEMA_CHANGE' | 'DEDUPLICATION_UPDATE' | 'ROUTING_UPDATE' | 'BREAKING_CHANGE'} changeCategory Change category (BUG_FIX, FEATURE_ADDITION, OPTIMIZATION, SCHEMA_CHANGE, DEDUPLICATION_UPDATE, ROUTING_UPDATE, BREAKING_CHANGE)
     * @param {IntegrationMappingEntity} integrationMappingEntity 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceMappingsApiInterface
     */
    updateMappingRaw(requestParameters: UpdateMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Update field mapping - automatically creates new version and recommends replay if needed
     * Update mapping
     */
    updateMapping(requestParameters: UpdateMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Validate if a field name is canonical and get suggestions if not
     * @summary Validate field name
     * @param {string} entityType Entity type
     * @param {string} fieldName Field name to validate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceMappingsApiInterface
     */
    validateFieldNameRaw(requestParameters: ValidateFieldNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Validate if a field name is canonical and get suggestions if not
     * Validate field name
     */
    validateFieldName(requestParameters: ValidateFieldNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Validate multiple field names in a single request for better performance
     * @summary Validate multiple field names (batch)
     * @param {string} entityType Entity type
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceMappingsApiInterface
     */
    validateFieldNamesBatchRaw(requestParameters: ValidateFieldNamesBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Validate multiple field names in a single request for better performance
     * Validate multiple field names (batch)
     */
    validateFieldNamesBatch(requestParameters: ValidateFieldNamesBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns config-time warnings for catch-all and multi-mapping routing (Slice 14.P1)
     * @summary Validate instance routing
     * @param {string} instanceId Instance ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceMappingsApiInterface
     */
    validateInstanceRoutingRaw(requestParameters: ValidateInstanceRoutingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns config-time warnings for catch-all and multi-mapping routing (Slice 14.P1)
     * Validate instance routing
     */
    validateInstanceRouting(requestParameters: ValidateInstanceRoutingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class IntegrationMarketplaceMappingsApi extends runtime.BaseAPI implements IntegrationMarketplaceMappingsApiInterface {

    /**
     * Create a new field mapping for an integration instance
     * Create mapping
     */
    async createMappingRaw(requestParameters: CreateMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling createMapping().'
            );
        }

        if (requestParameters['integrationMappingEntity'] == null) {
            throw new runtime.RequiredError(
                'integrationMappingEntity',
                'Required parameter "integrationMappingEntity" was null or undefined when calling createMapping().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['instanceId'] != null) {
            queryParameters['instanceId'] = requestParameters['instanceId'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/marketplace/mappings`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IntegrationMappingEntityToJSON(requestParameters['integrationMappingEntity']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Create a new field mapping for an integration instance
     * Create mapping
     */
    async createMapping(requestParameters: CreateMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.createMappingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all canonical field names for a given entity type (ASSET, APPLICATION, CONTAINER, VULNERABILITY, WEAKNESS, USER)
     * Get canonical fields
     */
    async getCanonicalFieldsRaw(requestParameters: GetCanonicalFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError(
                'entityType',
                'Required parameter "entityType" was null or undefined when calling getCanonicalFields().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/mappings/canonical-fields/{entityType}`;
        urlPath = urlPath.replace(`{${"entityType"}}`, encodeURIComponent(String(requestParameters['entityType'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all canonical field names for a given entity type (ASSET, APPLICATION, CONTAINER, VULNERABILITY, WEAKNESS, USER)
     * Get canonical fields
     */
    async getCanonicalFields(requestParameters: GetCanonicalFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getCanonicalFieldsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get common field name aliases/variations for a canonical field name
     * Get field aliases
     */
    async getFieldAliasesRaw(requestParameters: GetFieldAliasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError(
                'entityType',
                'Required parameter "entityType" was null or undefined when calling getFieldAliases().'
            );
        }

        if (requestParameters['canonicalField'] == null) {
            throw new runtime.RequiredError(
                'canonicalField',
                'Required parameter "canonicalField" was null or undefined when calling getFieldAliases().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/mappings/field-aliases/{entityType}/{canonicalField}`;
        urlPath = urlPath.replace(`{${"entityType"}}`, encodeURIComponent(String(requestParameters['entityType'])));
        urlPath = urlPath.replace(`{${"canonicalField"}}`, encodeURIComponent(String(requestParameters['canonicalField'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get common field name aliases/variations for a canonical field name
     * Get field aliases
     */
    async getFieldAliases(requestParameters: GetFieldAliasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getFieldAliasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get common field name aliases/variations for multiple canonical field names in a single request
     * Get field aliases for multiple fields (batch)
     */
    async getFieldAliasesBatchRaw(requestParameters: GetFieldAliasesBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError(
                'entityType',
                'Required parameter "entityType" was null or undefined when calling getFieldAliasesBatch().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling getFieldAliasesBatch().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['entityType'] != null) {
            queryParameters['entityType'] = requestParameters['entityType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/marketplace/mappings/field-aliases/batch`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get common field name aliases/variations for multiple canonical field names in a single request
     * Get field aliases for multiple fields (batch)
     */
    async getFieldAliasesBatch(requestParameters: GetFieldAliasesBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getFieldAliasesBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get change history for a single destination field within a mapping (add/remove/update with who and when)
     * Get field mapping history
     */
    async getFieldMappingHistoryRaw(requestParameters: GetFieldMappingHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['mappingId'] == null) {
            throw new runtime.RequiredError(
                'mappingId',
                'Required parameter "mappingId" was null or undefined when calling getFieldMappingHistory().'
            );
        }

        if (requestParameters['destinationField'] == null) {
            throw new runtime.RequiredError(
                'destinationField',
                'Required parameter "destinationField" was null or undefined when calling getFieldMappingHistory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['destinationField'] != null) {
            queryParameters['destinationField'] = requestParameters['destinationField'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/mappings/{mappingId}/field-history`;
        urlPath = urlPath.replace(`{${"mappingId"}}`, encodeURIComponent(String(requestParameters['mappingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get change history for a single destination field within a mapping (add/remove/update with who and when)
     * Get field mapping history
     */
    async getFieldMappingHistory(requestParameters: GetFieldMappingHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getFieldMappingHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get mapping configuration including mapping-scoped trigger rules
     * Get mapping
     */
    async getMappingRaw(requestParameters: GetMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['mappingId'] == null) {
            throw new runtime.RequiredError(
                'mappingId',
                'Required parameter "mappingId" was null or undefined when calling getMapping().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/mappings/{mappingId}`;
        urlPath = urlPath.replace(`{${"mappingId"}}`, encodeURIComponent(String(requestParameters['mappingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get mapping configuration including mapping-scoped trigger rules
     * Get mapping
     */
    async getMapping(requestParameters: GetMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getMappingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get version history for a field mapping
     * Get mapping versions
     */
    async getMappingVersionsRaw(requestParameters: GetMappingVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['mappingId'] == null) {
            throw new runtime.RequiredError(
                'mappingId',
                'Required parameter "mappingId" was null or undefined when calling getMappingVersions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/mappings/{mappingId}/versions`;
        urlPath = urlPath.replace(`{${"mappingId"}}`, encodeURIComponent(String(requestParameters['mappingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get version history for a field mapping
     * Get mapping versions
     */
    async getMappingVersions(requestParameters: GetMappingVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getMappingVersionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all field mappings for an integration instance
     * Get mappings
     */
    async getMappingsRaw(requestParameters: GetMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling getMappings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/mappings/instance/{instanceId}`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all field mappings for an integration instance
     * Get mappings
     */
    async getMappings(requestParameters: GetMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all available transform types for field mappings
     * Get transform types
     */
    async getTransformTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/mappings/transform-types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all available transform types for field mappings
     * Get transform types
     */
    async getTransformTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getTransformTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Apply FieldNormalizationService to a transformed mapping preview record so operators see canonical keys MDM/load will receive
     * Normalize mapped record preview
     */
    async normalizeMappingPreviewRaw(requestParameters: NormalizeMappingPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError(
                'entityType',
                'Required parameter "entityType" was null or undefined when calling normalizeMappingPreview().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling normalizeMappingPreview().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['entityType'] != null) {
            queryParameters['entityType'] = requestParameters['entityType'];
        }

        if (requestParameters['sourceSystem'] != null) {
            queryParameters['sourceSystem'] = requestParameters['sourceSystem'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/marketplace/mappings/normalize-preview`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Apply FieldNormalizationService to a transformed mapping preview record so operators see canonical keys MDM/load will receive
     * Normalize mapped record preview
     */
    async normalizeMappingPreview(requestParameters: NormalizeMappingPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.normalizeMappingPreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Rollback to a previous version of a field mapping
     * Rollback mapping
     */
    async rollbackMappingRaw(requestParameters: RollbackMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['mappingId'] == null) {
            throw new runtime.RequiredError(
                'mappingId',
                'Required parameter "mappingId" was null or undefined when calling rollbackMapping().'
            );
        }

        if (requestParameters['versionNumber'] == null) {
            throw new runtime.RequiredError(
                'versionNumber',
                'Required parameter "versionNumber" was null or undefined when calling rollbackMapping().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['versionNumber'] != null) {
            queryParameters['versionNumber'] = requestParameters['versionNumber'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/mappings/{mappingId}/rollback`;
        urlPath = urlPath.replace(`{${"mappingId"}}`, encodeURIComponent(String(requestParameters['mappingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Rollback to a previous version of a field mapping
     * Rollback mapping
     */
    async rollbackMapping(requestParameters: RollbackMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.rollbackMappingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update field mapping - automatically creates new version and recommends replay if needed
     * Update mapping
     */
    async updateMappingRaw(requestParameters: UpdateMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['mappingId'] == null) {
            throw new runtime.RequiredError(
                'mappingId',
                'Required parameter "mappingId" was null or undefined when calling updateMapping().'
            );
        }

        if (requestParameters['changeSummary'] == null) {
            throw new runtime.RequiredError(
                'changeSummary',
                'Required parameter "changeSummary" was null or undefined when calling updateMapping().'
            );
        }

        if (requestParameters['changeReason'] == null) {
            throw new runtime.RequiredError(
                'changeReason',
                'Required parameter "changeReason" was null or undefined when calling updateMapping().'
            );
        }

        if (requestParameters['changeCategory'] == null) {
            throw new runtime.RequiredError(
                'changeCategory',
                'Required parameter "changeCategory" was null or undefined when calling updateMapping().'
            );
        }

        if (requestParameters['integrationMappingEntity'] == null) {
            throw new runtime.RequiredError(
                'integrationMappingEntity',
                'Required parameter "integrationMappingEntity" was null or undefined when calling updateMapping().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['changeSummary'] != null) {
            queryParameters['changeSummary'] = requestParameters['changeSummary'];
        }

        if (requestParameters['changeReason'] != null) {
            queryParameters['changeReason'] = requestParameters['changeReason'];
        }

        if (requestParameters['changeCategory'] != null) {
            queryParameters['changeCategory'] = requestParameters['changeCategory'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/marketplace/mappings/{mappingId}`;
        urlPath = urlPath.replace(`{${"mappingId"}}`, encodeURIComponent(String(requestParameters['mappingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IntegrationMappingEntityToJSON(requestParameters['integrationMappingEntity']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Update field mapping - automatically creates new version and recommends replay if needed
     * Update mapping
     */
    async updateMapping(requestParameters: UpdateMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateMappingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate if a field name is canonical and get suggestions if not
     * Validate field name
     */
    async validateFieldNameRaw(requestParameters: ValidateFieldNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError(
                'entityType',
                'Required parameter "entityType" was null or undefined when calling validateFieldName().'
            );
        }

        if (requestParameters['fieldName'] == null) {
            throw new runtime.RequiredError(
                'fieldName',
                'Required parameter "fieldName" was null or undefined when calling validateFieldName().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['entityType'] != null) {
            queryParameters['entityType'] = requestParameters['entityType'];
        }

        if (requestParameters['fieldName'] != null) {
            queryParameters['fieldName'] = requestParameters['fieldName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/mappings/validate-field-name`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Validate if a field name is canonical and get suggestions if not
     * Validate field name
     */
    async validateFieldName(requestParameters: ValidateFieldNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.validateFieldNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate multiple field names in a single request for better performance
     * Validate multiple field names (batch)
     */
    async validateFieldNamesBatchRaw(requestParameters: ValidateFieldNamesBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError(
                'entityType',
                'Required parameter "entityType" was null or undefined when calling validateFieldNamesBatch().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling validateFieldNamesBatch().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['entityType'] != null) {
            queryParameters['entityType'] = requestParameters['entityType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/marketplace/mappings/validate-field-names`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Validate multiple field names in a single request for better performance
     * Validate multiple field names (batch)
     */
    async validateFieldNamesBatch(requestParameters: ValidateFieldNamesBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.validateFieldNamesBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns config-time warnings for catch-all and multi-mapping routing (Slice 14.P1)
     * Validate instance routing
     */
    async validateInstanceRoutingRaw(requestParameters: ValidateInstanceRoutingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling validateInstanceRouting().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['instanceId'] != null) {
            queryParameters['instanceId'] = requestParameters['instanceId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/mappings/routing-validation`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns config-time warnings for catch-all and multi-mapping routing (Slice 14.P1)
     * Validate instance routing
     */
    async validateInstanceRouting(requestParameters: ValidateInstanceRoutingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.validateInstanceRoutingRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const UpdateMappingChangeCategoryEnum = {
    BugFix: 'BUG_FIX',
    FeatureAddition: 'FEATURE_ADDITION',
    Optimization: 'OPTIMIZATION',
    SchemaChange: 'SCHEMA_CHANGE',
    DeduplicationUpdate: 'DEDUPLICATION_UPDATE',
    RoutingUpdate: 'ROUTING_UPDATE',
    BreakingChange: 'BREAKING_CHANGE'
} as const;
export type UpdateMappingChangeCategoryEnum = typeof UpdateMappingChangeCategoryEnum[keyof typeof UpdateMappingChangeCategoryEnum];
